// @fullpage/react-fullpage 这个包收费，所以用react-page-scroll平替
import { useState } from 'react';
// import PageScroll, { NestedPageScroll } from 'react-page-scroll';
// import ReactPageScroller  from 'react-page-scroller';
import ReactFullpage from '@fullpage/react-fullpage';
import { Banner, AboutUs, CorporateBusiness, CustomerStories, CooperativePartner } from './components';

import CustomerCase from '../CustomerCase';
import AboutUsPage from '../AboutUs';

import styles from './index.module.css';

import logo2 from './images/logo2.png';
import logo2x from './images/logo2x.png';

const cnMenuMap = {
    'Homepage': '首页',
    'Customer Case': '客户案例',
    'About US': '关于我们'
};

const enMenuMap = {
    'Homepage': 'Homepage',
    'Customer Case': 'Customer Case',
    'About US': 'About US'
};

const text = {
    cn: {
        menu: ['Homepage', 'Customer Case', 'About US'],
        menuMap: cnMenuMap,
    },
    en: {
        menu: ['Homepage', 'Customer Case', 'About US'],
        menuMap: enMenuMap
    }
}

const HomePage = () => {
    const [l, setL] = useState('cn');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [path, setPath] = useState('Homepage');
    const [isShowHeader, setIsShowHeader] = useState(true);
    const [isBlack, setIsBlack] = useState(false);

    const gettitleCalor = (isChecked, currentIndex, isB) => {
        if (path === 'Homepage' && isChecked && currentIndex === 0) {
            return '#fff';
        }
        if (path === 'Homepage' && isChecked && currentIndex > 0) {
            return '#222';
        }
        if (isChecked && isB) {
            return '#222';
        }
        if (isChecked) {
            return '#fff';
        }
    }

    const getlogosrc = () => {
        if (path === 'Homepage' && currentIndex === 0) {
            return logo2x;
        }
        if (path === 'Homepage' && currentIndex > 0) {
            return logo2;
        }
        if (isBlack) {
            return logo2;
        }
        return logo2x;
    }

    const getHeaderBackColor = () => {
        if (isBlack || currentIndex > 0) {
            return '#fff'
        }
    }

    // const getHeaderBor = () => {
    //     if (isBlack) {
    //         return '0px -10px 10px 4px #000'
    //     }
    // }

    return (
        <div className={styles['body']}>
            <div
                className={styles['header-box']}
                onMouseEnter={() => {
                    if (currentIndex !== 0) {
                        setIsShowHeader(true);
                    }
                }}
                onMouseLeave={() => {
                    if (currentIndex !== 0) {
                        setIsShowHeader(false);
                    }
                }}
            >
                <div
                    className={styles['header']}
                    style={{
                        top: isShowHeader ? 0 : -100,
                        background: getHeaderBackColor(),
                        // boxShadow: getHeaderBor()
                    }}
                >
                    <div className={styles['menu']}>
                        {text[l]['menu'].map(item => (
                            <div className={styles['menu-item']}>
                                <span
                                    className={styles['menu-item-title']}
                                    style={{
                                        color: gettitleCalor(path === item, currentIndex, isBlack),
                                        fontWeight: path === item ? 'bold' : undefined,
                                    }}
                                    onClick={() => {
                                        if (item !== path) {
                                            setPath(item);
                                            if(item !== 'Homepage'){
                                                setCurrentIndex(0);
                                            } else {
                                                // setCurrentIndex(currentIndex - 1);
                                            }
                                        }
                                    }}
                                >
                                    {text[l]['menuMap'][item]}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div className={styles['l-chenge']}>
                        {[{ label: 'EN', value: 'en' }, { label: '中文', value: 'cn' }].map(item => (
                            <div className={styles['l-item']}>
                                <span
                                    className={styles['l-item-title']}
                                    onClick={() => {
                                        console.log(item.value)
                                        setL(item.value)
                                    }}
                                    style={{
                                        color: gettitleCalor(l === item.value, currentIndex, isBlack),
                                        fontWeight: l === item.value ? 'bold' : undefined,
                                    }}
                                >
                                    {item.label}
                                </span>
                            </div>
                        ))}
                    </div>
                    <img className={styles['logo']} src={getlogosrc()} alt='' />
                </div>
            </div>
            {/* {path === 'Homepage' && (
                <PageScroll
                    width='100%'
                    height="100vh"
                    onScrollEnd={({ currentIndex }) => {
                        setCurrentIndex(currentIndex);
                        if (currentIndex === 0) {
                            setIsShowHeader(true)
                        } else {
                            setIsShowHeader(false);
                        }
                    }}
                    onScrollInit={({ scrollControl }) => {
                        // setNext(scrollControl.scrollTo)
                    }}
                >
                    <NestedPageScroll direction="horizontal" width="100%" height="100vh">
                        <Banner />
                    </NestedPageScroll>
                    <NestedPageScroll direction="horizontal" width="100%" height="100vh">
                        <AboutUs currentIndex={currentIndex} l={l} isShowBtn setPath={setPath} />
                    </NestedPageScroll>
                    <NestedPageScroll direction="horizontal" width="100%" height="100vh">
                        <CorporateBusiness currentIndex={currentIndex} l={l} />
                    </NestedPageScroll>
                    <NestedPageScroll direction="horizontal" width="100%" height="100vh">
                        <CustomerStories currentIndex={currentIndex} l={l} setPath={setPath} />
                    </NestedPageScroll>
                    <NestedPageScroll direction="horizontal" width="100%" height="100vh">
                        <CooperativePartner l={l} />
                    </NestedPageScroll>
                </PageScroll>
            )} */}
            {
                path === 'Homepage' && (
                    <ReactFullpage
                        scrollingSpeed={500} /* Options here */
                        onLeave={(_, { index }) => {
                            setCurrentIndex(index);
                            if (index === 0) {
                                setIsShowHeader(true)
                            } else {
                                setIsShowHeader(false);
                            }
                        }}
                        render={({ state, fullpageApi }) => {
                            return (
                                <>

                                    <ReactFullpage.Wrapper>
                                        <div className="section">
                                            <div>
                                                <Banner />
                                                <div className={styles['bown-icon']}
                                                    onClick={() => {
                                                        fullpageApi.moveSectionDown();
                                                    }}
                                                    style={{
                                                        bottom: '5.5%'
                                                    }}
                                                >
                                                    <div className={styles['icon-jump']}></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="section">
                                            <div>
                                                <AboutUs currentIndex={currentIndex} l={l} isShowBtn setPath={(val) => {
                                                    setPath(val);
                                                    setCurrentIndex(0);
                                                    setIsShowHeader(true);
                                                }}  />
                                                <div className={styles['bown-icon']}
                                                    onClick={() => {
                                                        fullpageApi.moveSectionDown();
                                                    }}
                                                    style={{
                                                        top: '193%'
                                                    }}
                                                >
                                                    <div className={styles['icon-jump']}></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="section">
                                            <div>
                                                <CorporateBusiness currentIndex={currentIndex} l={l} />
                                                <div className={styles['bown-icon']}
                                                    onClick={() => {
                                                        fullpageApi.moveSectionDown();
                                                    }}
                                                    style={{
                                                        top: '293%'
                                                    }}
                                                >
                                                    <div className={styles['icon-jump']}></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="section">
                                            <div>
                                                <CustomerStories currentIndex={currentIndex} l={l} setPath={(val) => {
                                                    setPath(val);
                                                    setCurrentIndex(0);
                                                    setIsShowHeader(true);
                                                }} />
                                                <div className={styles['bown-icon']}
                                                    onClick={() => {
                                                        fullpageApi.moveSectionDown();
                                                    }}
                                                    style={{
                                                        top: '393%'
                                                    }}
                                                >
                                                    <div className={styles['icon-jump']}></div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="section">
                                            <CooperativePartner l={l} />
                                        </div>
                                    </ReactFullpage.Wrapper>
                                </>

                            );
                        }}
                    />

                )
            }
            {/* {path === 'Homepage' && (
                <ReactPageScroller
                    pageOnChange={(currentIndex) => {
                        setCurrentIndex(currentIndex);
                        if (currentIndex === 0) {
                            setIsShowHeader(true)
                        } else {
                            setIsShowHeader(false);
                        }
                    }}
                    // animationTimer={500}
                    // animationTimerBuffer={500}
                    // customPageNumber={3}
                    
                >
                    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                        <Banner />
                    </div>
                    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                        <AboutUs currentIndex={currentIndex} l={l} isShowBtn setPath={setPath} />
                    </div>
                    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                        <CorporateBusiness currentIndex={currentIndex} l={l} />
                    </div>
                    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                        <CustomerStories currentIndex={currentIndex} l={l} setPath={setPath} />
                    </div>
                    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                        <CooperativePartner l={l} />
                    </div>


                </ReactPageScroller>
            )} */}
            {path === 'Customer Case' && (
                <CustomerCase l={l} setIsBlack={setIsBlack} path={path} />
            )}
            {path === 'About US' && (
                <AboutUsPage l={l} setIsBlack={setIsBlack} path={path} />
            )}
        </div>
    )
}

export default HomePage;